import { render, staticRenderFns } from "./bv-tab-bar.vue?vue&type=template&id=3e7a451f&scoped=true&"
import script from "./bv-tab-bar.vue?vue&type=script&lang=js&"
export * from "./bv-tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./bv-tab-bar.vue?vue&type=style&index=0&id=3e7a451f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../apps/life_driving_school/node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7a451f",
  null
  
)

export default component.exports